import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { theme } from "./branding";
import { StateProvider } from "./context/StateContext";
import LandingPage from "./pages/LandingPage/LandingPage";
import Logout from "./pages/Logout/Logout";
import { NewPasswordPage } from "./pages/NewPasswordPage";
import { AppLogout } from "./pages/AppLogout/AppLogout";
import "./index.css";
import CookieBanner from "./components/CookieBanner";
import { Box, Link, Typography } from "@mui/material";
import { useStateContext } from "./context/StateContext";

const CookieSettingsFooter = () => {
	const { state, dispatch } = useStateContext();

	if (state.loadingForCookies) return null;

	return (
		<Box
			sx={{
				display: "flex",
				height: "50px",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<CookieBanner />
			<Typography>
				<Link
					onClick={() => {
						dispatch({
							type: "COOKIE_SETTINGS_OPENED",
							payload: true,
						});
					}}
				>
					Cookie settings
				</Link>
			</Typography>
		</Box>
	);
};

function App() {
	return (
		<div className="App">
			<StyledEngineProvider injectFirst>
				<ThemeProvider theme={theme}>
					<StateProvider>
						<Box
							sx={{
								minHeight: "100vh",
								display: "flex",
								flexDirection: "column",
								justifyContent: "space-between",
							}}
						>
							<BrowserRouter>
								<Switch>
									<Route exact path="/app-logout">
										<AppLogout />
									</Route>
									<Route exact path="/logout">
										<Logout />
									</Route>
									<Route exact path="/new-password">
										<NewPasswordPage />
									</Route>
									<Route path="/">
										<LandingPage />
									</Route>
								</Switch>
							</BrowserRouter>
							<CookieSettingsFooter />
						</Box>
					</StateProvider>
				</ThemeProvider>
			</StyledEngineProvider>
		</div>
	);
}

export default App;
